import React from 'react';
import { Card, Typography, Space } from 'antd';
import { useAuth } from '../../components/Layout/AuthContext';

const { Title, Paragraph } = Typography;

const Welcome: React.FC = () => {
  const { staff } = useAuth();
  const name = staff?.name || staff?.username || '用户';

  return (
    <div style={{ padding: '24px' }}>
      <Card bordered={false}>
        <div style={{ textAlign: 'center', padding: '40px 0' }}>
          <Space direction="vertical" size="large">
            <Title level={2}>欢迎回来，{name}</Title>
            <Paragraph type="secondary" style={{ fontSize: '16px' }}>
              欢迎使用 租赁业务风控系统
            </Paragraph>
            <Paragraph>
              请点击左侧菜单栏进行操作，如果您没有看到任何菜单，请联系管理员分配权限。
            </Paragraph>
          </Space>
        </div>
      </Card>
    </div>
  );
};

export default Welcome;
